export class Trascodifica {
	id: number;
	codice: string;
	descrizione: string;
	dominio: string;
	children: Trascodifica[];
	parent: Trascodifica;
	parentDescrizione: string;
	get itemName(): string { return this.descrizione; }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/trascodifica.ts